import { Paragraph } from '@eggplant/pattern-library'

const SmtpSetup = () =>
  <Paragraph>
    You must configure an email server and sender before  notifications can be sent.
  </Paragraph>

export default SmtpSetup
